import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { formatTime12h } from '../utils/time';

export default function Streaks({ userId }) {
  const [meds, setMeds] = useState([]);
  const [streaks, setStreaks] = useState({});

  useEffect(() => {
    api.getMedications(userId).then(data => {
      const daily = data.filter(m => m.type === 'daily');
      setMeds(daily);
      daily.forEach(m => {
        api.getStreak(m.id)
          .then(s => setStreaks(prev => ({ ...prev, [m.id]: s })))
          .catch(() => {});
      });
    });
  }, [userId]);

  if (meds.length === 0) return null;

  return (
    <div className="streaks-card">
      <h2>🔥 Streaks</h2>
      <div className="streak-list">
        {meds.map(m => {
          const s = streaks[m.id];
          return (
            <div key={m.id} className="streak-item">
              <div className="streak-name-group">
                <span className="streak-name">{m.name}</span>
                {m.effective_reminder_time && <span className="time-chip">{formatTime12h(m.effective_reminder_time)}</span>}
              </div>
              <div className="streak-nums">
                <span className="streak-current" title="Current streak">
                  🔥 {s ? s.current_streak : '—'} days
                </span>
                <span className="streak-best" title="Longest streak">
                  🏆 {s ? s.longest_streak : '—'} best
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
